import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector,useDispatch } from 'react-redux'
import { baseUrlback } from "../urlApi";








export const UseGetEmpleadosSinDoc =  () => {

  const [empleados, setEmpleados] = useState([])
  const [empleadosNoVigentes, setEmpleadosNoVigentes] = useState([])
  const [empleadosVigentes, setEmpleadosVigentes] = useState([])

  const [centroCosto, setCentroCosto] = useState([])
  // const local = useSelector(state => state.app.local)
  const dispatch = useDispatch()

  const empresa  = useSelector(state => state.app.empresa)


  const vigentes  = useSelector(state => state.app.vigentes)

  // const {local,vigentes} = useSelector( (state) => state.app  )

  const sid =  localStorage.getItem('sid')
  const strcon = localStorage.getItem('strcon')
  const codigo= localStorage.getItem('codigo')
  // console.log('yapo')
    
  
  const decrypt = localStorage.getItem('decrypt')

  let portal = localStorage.getItem('sid')

  const [dataTrabajadores, setdataTrabajadores] = useState([])




    const consultarDatos = async() => {

      // console.log('AAAAAAAAA')

              try {

                const response = await axios.get(`${baseUrlback}api/carpeta/trabajadores/${empresa.value}/${portal}/${decrypt}`,{
                  headers:{
                    'sid':sid,
                    'strcon':strcon,
                    'codigo':codigo
                 }
                 })

                setdataTrabajadores(response)
      
                const arrayFecha = response.data[0].hasta.split('-')


        

                const trabajadoresNoVigentes = response.data
                const trabajadoresVigentes = response.data.filter(item => new Date(item.hasta.split('-')[0],item.hasta.split('-')[1]-1,item.hasta.split('-')[2]).getTime() >  new Date().getTime() || item.hasta === '0000-00-00' )

          
                const trabajadores = trabajadoresVigentes.map(({nombreCompleto,rut, codper, email, id, emailok,ccosto,cargo,sucursal}) => {
                  return { value: rut , nombreCompleto, codper, email, conid:id, emailok,ccosto,cargo,sucursal,  label: `${nombreCompleto}  ${rut}` };
                })
                
          
                const dataArr = new Set(trabajadores.map( JSON.stringify ))
                let trabajadoresSinDuplicados = Array.from( dataArr ).map( JSON.parse )

                const trabajadoresNoVigentesFormat= trabajadoresNoVigentes.map(({nombreCompleto,rut, codper, email, id, emailok,ccosto,cargo,sucursal}) => {
                  return { value: rut , nombreCompleto, codper, email, conid:id, emailok,ccosto,cargo,sucursal, label: `${nombreCompleto}  ${rut}`   };
                })

                const dataArrNoVigentes = new Set(trabajadoresNoVigentesFormat.map( JSON.stringify ))
                let trabajadoresSinDuplicadosNoVigentes = Array.from( dataArrNoVigentes ).map( JSON.parse )
          
                // console.log('trabajadoresSinDuplicados',trabajadoresSinDuplicados)

                
                setEmpleadosVigentes(trabajadoresSinDuplicados)
                setEmpleadosNoVigentes(trabajadoresSinDuplicadosNoVigentes)

                if(vigentes){

                  setEmpleados(trabajadoresSinDuplicados)

                  filterCcosto(trabajadoresVigentes)
          
                } else {
                  setEmpleados(trabajadoresSinDuplicadosNoVigentes)

                  filterCcosto(trabajadoresNoVigentes)
                  
                }


                // Obtenemos los centros de costo de los trabajadore VIGENTES
                

               
                
                
              } catch (error) {
                console.log(error)

             

      
      

              }
          



    }


    useEffect(() => {
      
      if(empresa.value){
        consultarDatos()

      }

    }, [empresa])

    useEffect(() => {
      
      if(vigentes){

        setEmpleados(empleadosVigentes)
        filterCcosto(empleadosVigentes)


      } else {
        setEmpleados(empleadosNoVigentes)
        filterCcosto(empleadosNoVigentes)

      }

    }, [vigentes])

    const filterCcosto = (arrayTrabajadores) => {
      const ccosto = arrayTrabajadores.map(  item =>  { return  item.ccosto } )
      const uniqueCcosto = [...new Set(ccosto.map(item => item))]; 
      const uniqueFilterCcosto = uniqueCcosto.filter( item => item.length >= 1)
      const ccostoFinal = uniqueFilterCcosto.map(  item =>  { return { label: item, value:item } } )
      ccostoFinal.push({ label: 'Todos', value:'Todos' })

      setCentroCosto(ccostoFinal.reverse())
    }



 

    return { 
      empleados, setEmpleados, dataTrabajadores, setdataTrabajadores,empleadosNoVigentes,centroCosto
    
    }


  }



